import { ViewModel, View, ObservableArray } from "binder";
import { MultiSelectorBaseViewModel } from "src/common/reusableComponents/multiSelectorBase/multiSelectorBase-viewModel";
import { SelectorBaseViewModel } from "src/common/reusableComponents/selectorBase/selectorBase-viewModel";
import { ServerConnection } from "src/server/serverConnection";

export class DistinguishingDetailValueSelectorViewModel extends SelectorBaseViewModel<distinguishingDetailForSelector> {
    constructor(parentViewModel: ViewModel) {
        super(parentViewModel);
        this.details = ObservableArray.create<SpecifiedDistinguishingDetailAndDetail>();
    }
    public set details(v: ObservableArray<SpecifiedDistinguishingDetailAndDetail>) { 
        this._details = v;
        this.refresh();
     } public get details(): ObservableArray<SpecifiedDistinguishingDetailAndDetail> { return this._details;} private _details: ObservableArray<SpecifiedDistinguishingDetailAndDetail>;
    
    protected async loadData(): Promise<distinguishingDetailForSelector[]> {
        if(this.details==null || this.details.length == 0)
            return [];

        let result = await ServerConnection.callServer('/Complex/AccountingServices/GetDistinguishingDetailValues', {
            DetailAndDistiguishingIds: this.details.map(d => {
                return {
                    DetailId: d.detailId,
                    SpecifiedDistinguishingDetailId: d.distinguishingDetail,
                };
            })
        });
        return result.Details.map(q => {
            return q.Values.map(v => {
                let r = new distinguishingDetailForSelector(this);
                r.id = v.Id;
                r.detailId = q.SpecifiedDistinguishingDetailId;
                r.detailName = q.Name;
                r.nameValue = v.Value;
                r.codeValue = v.Code;
                r.title = `${q.Name}: ${v.Value}`;
                return r;
            });
        }).reduce(function(a, b){ return a.concat(b); }, []);
    }
}

export class distinguishingDetailForSelector extends ViewModel {
    public getTypeId(): string { return ''; }
    public GetDefaultView(): View<ViewModel> { return null; }
    constructor(parent: ViewModel) {
        super(parent);

    }

    public set id(v: string) { this._id = v; } public get id(): string { return this._id; } private _id: string;
    public set detailId(v: string) { this._detailId = v; } public get detailId(): string { return this._detailId;} private _detailId: string;
    public set detailName(v: string) { this._detailName = v; } public get detailName(): string { return this._detailName; } private _detailName: string;
    public set title(v: string) { this._title = v; } public get title(): string { return this._title; } private _title: string;
    public set codeValue(v: string) { this._codeValue = v; } public get codeValue(): string { return this._codeValue;} private _codeValue: string;
    public set nameValue(v: string) { this._nameValue = v; } public get nameValue(): string { return this._nameValue;} private _nameValue: string;
    
}

export class SpecifiedDistinguishingDetailAndDetail extends ViewModel{
    public getTypeId(): string {return '';}
    public GetDefaultView(): View<ViewModel> {return null;}
    constructor(parent:ViewModel) {
        super(parent);
        
    }
    
    public set detailId(v: string) { this._detailId = v; } public get detailId(): string { return this._detailId;} private _detailId: string;
    public set distinguishingDetail(v: string) { this._distinguishingDetail = v; } public get distinguishingDetail(): string { return this._distinguishingDetail;} private _distinguishingDetail: string;
    
}
